import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FeatureFlagModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    currentFeatureFlagId: string | undefined;
    onSave: (featureFlagId: string | undefined) => void;
}

export function FeatureFlagModal({
    open,
    onOpenChange,
    currentFeatureFlagId,
    onSave,
}: FeatureFlagModalProps) {
    const [featureFlagId, setFeatureFlagId] = useState(currentFeatureFlagId || "");

    // Update the internal state when the modal opens with a different value
    useEffect(() => {
        if (open) {
            setFeatureFlagId(currentFeatureFlagId || "");
        }
    }, [open, currentFeatureFlagId]);

    const handleSave = () => {
        // Save empty string as undefined
        onSave(featureFlagId.trim() === "" ? undefined : featureFlagId.trim());
        onOpenChange(false);
    };

    const handleClear = () => {
        setFeatureFlagId("");
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Feature Flag</DialogTitle>
                    <DialogDescription>
                        Set a feature flag ID that could control the visibility of this block.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="feature-flag-id" className="text-right">
                            Flag ID
                        </Label>
                        <Input
                            id="feature-flag-id"
                            value={featureFlagId}
                            onChange={e => setFeatureFlagId(e.target.value)}
                            placeholder="e.g., new-feature-flag"
                            className="col-span-3"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={handleClear}>
                        Clear
                    </Button>
                    <Button onClick={handleSave}>Save</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
